import { host } from "../../../assets/constants/host";

export const apiGetListTransactions = `${host}/backoffice/filter-transactions`
export const apiExportListTransactions = `${host}/backoffice/export-trans`
